<template>
  <div>
    <modal-cadu close :width="600" v-model="show">
      <div slot="all" class="pt-10 pb-4 px-10">
        <div slot="header">
          <div
            class="font-secundaria headline font-weight-bold pb-4"
            style="color: #00995D"
          >EDITAR DATA VALIDADE DO TOKEN</div>
        </div>
        <div slot="body">
          <ValidationObserver ref="observer">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <input-cadu title="Usuário WS" v-model="nomeAplicacao" :disabled="true" />
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <input-cadu title="Token" v-model="tokenAplicacao" :disabled="true" :onlyUpperCase="false" :onlylowerCase="false"/>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <span>Status</span>
                    <v-row no-gutters justify="start" align="center">
                      <v-col cols="auto">
                        <div class="grey2--text">{{statusAtiva ? 'Ativa' : 'Inativa'}}</div>
                      </v-col>
                      <v-col class="ml-3" style="height: 18px;" cols="auto">
                        <switch-cadu v-model="statusAtiva" :disabled="true" />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="12" md="6">
                    <datepicker-cadu
                      :menuOpen="showDatePicker"
                      :inputTitle="'Data validade Token'"
                      :inputValue="dataExpiracao"
                      :minDate="today"
                      typeCalendar="date"
                      validateProviderRules="required"
                      @value="value => dataExpiracao= value"
                      width="280"
                    ></datepicker-cadu>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </ValidationObserver>
        </div>
        <div slot="footer" class="pt-6">
          <v-row>
            <v-col>
              <v-row justify="start">
                <v-col cols="auto">
                  <button-cadu outline @click="$emit('input', false)">VOLTAR</button-cadu>
                </v-col>
              </v-row>
            </v-col>
            <v-col>
              <v-row justify="end">
                <v-col cols="auto">
                  <button-cadu @click="finalizar">SALVAR</button-cadu>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </div>
    </modal-cadu>

    <overlay-loading v-model="loadingOverlay" />
    <error-modal v-model="error" :errObj="errObj" />
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'

import GerenciamentoToken from '../../../../../services/GerenciamentoToken/GerenciamentoToken'

export default {
  components: {
    ValidationObserver
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    dadosAplicacao: {
      type: Object
    }
  },
  data () {
    return {
      show: this.value,
      nomeAplicacao: '',
      tokenAplicacao: '',
      statusAtiva: true,
      tokenBearer: localStorage.getItem('tokenBearer'),
      today: '',
      login: '',

      // DatePicker
      showDatePicker: false,
      dataExpiracao: '',

      loadingOverlay: false,

      // Erro
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      }
    }
  },
  methods: {
    async finalizar () {
      const res = await this.$refs.observer.validate()
      if (res) {
        const objeto = {
          dataExpiracao: this.dataExpiracao,
          nome: this.nomeAplicacao
        }
        await this.putEditarValidadeToken(objeto)
      }
    },
    limparCampos () {
      this.dataExpiracao = ''
    },
    preencherDados () {
      this.nomeAplicacao = this.dadosAplicacao.nome
      this.tokenAplicacao = this.dadosAplicacao.token
      this.statusAtiva = this.dadosAplicacao.status
      this.today = this.dadosAplicacao.dataGeracao
    },

    isDateValidadeMaiorHoje (value) {
      var parts = value.split('/')
      var day = parseInt(parts[0], 10)
      var month = parseInt(parts[1], 10)
      var year = parseInt(parts[2], 10)

      let myDate = new Date(year, month - 1, day)
      let dateNow = new Date()

      return myDate > dateNow
    },

    async putEditarValidadeToken (objeto) {
      this.loadingOverlay = true
      let gerenciamento = new GerenciamentoToken(
        this.tokenBearer,
        this.$appConfig.config.API
      )

      try {
        await gerenciamento.putAtualizarToken(objeto, this.dadosAplicacao.id)
        this.show = false
        this.loadingOverlay = false
        this.$emit('finalizar', this.isDateValidadeMaiorHoje(this.dataExpiracao))
      } catch (err) {
        this.loadingOverlay = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    }
  },
  watch: {
    value () {
      this.show = this.value
    },
    show () {
      if (!this.show) {
        this.limparCampos()
      } else {
        this.preencherDados()
      }
      this.$emit('input', this.show)
    }
  }
}
</script>

<style>
</style>
